export const SUCCESS_RESPONSE_CODE = '00';
export const SUCCESS_RESPONSE_CODE_TAC = '0';
export const MULTIPLE_SESSION_RESPONSE_CODE = '58';
export const EXPIRED_SESSION_RESPONSE_CODE = '59';
export const ERROR_M9_RESPONSE_CODE = 'M9';
export const REJECT_TRANSACTION_SECURE2U_RESPONSE_CODE = '98';
export const USER_TAC_LOCK_RESPONSE_CODE = '96';
export const USER_BLOCKED_RESPONSE_CODE = '97';

// NOTE: HTTP response status code
export const HTTP_SUCCESS = 200;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_INTERNAL_SERVER_ERROR = 500;
// add 215 code
export const HTTP_ERROR_215 = '215';

// NOTE: API responseCode
export const CC_DISPLAY_RESPONSE_CODE = 'M9';
export const UNRESPONSIVE_HOST = 'UNRESPONSIVE_HOST';
export const TAC_LOCKED = 32;
export const ACCOUNT_MAINTENANCE_ERROR = '90';
export const SYSTEM_ERROR = 99;
export const JWT_TOKEN_EXPIRED = '999';
export const DIGITAL_WEALTH_BTS_OFFLINE = '88';

// Registration page response code
export const NEW_ACCOUNT_CODE = '75';
export const TAC_EXCEED_MAX_TRIES = '32';
export const INVALID_CREDENTIAL = '13';
export const ACCOUNT_EXIST_CODE = '86';

// Check the access / service statuses
export const STATUS_ONLINE = '0';
export const STATUS_OFFLINE = '1';

export const EXCEEED_TRANSCTION_LIMIT = '30';
export const BELOW_TRANSACTION_LIMIT = '1300';
export const INVALID_BENEFICIARY_ACCOUNT = '104';

// For Transfer result
export const NON_ESB_STATUSCODE = '-1';
export const EXCEED_CUTOFF_TIME = '59';
export const SWIFT_EXCEED_CUTOFF_TIME = '107';
export const SWIFT_ABOVE_THRESHOLD_RESPONSE_CODE = '89';
